import React, { HTMLProps, ReactNode } from "react";
import styled from "styled-components";
import { ReferralCampaignStatus } from "../referral-campaigns.model";

export interface IReferralCampaignStatusChipProps extends HTMLProps<HTMLDivElement> {
  status: ReferralCampaignStatus;
  children: ReactNode;
}

/**
 * ReferralCampaignStatusChip component
 */
const ReferralCampaignStatusChip = ({ status, children, ref, as, ...rest }: IReferralCampaignStatusChipProps) => {
  return (
    <StatusChipContainer status={status} {...rest}>
      {children}
    </StatusChipContainer>
  );
};

export default ReferralCampaignStatusChip;

const StatusChipContainer = styled("div")<{ status: ReferralCampaignStatus }>`
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  height: 22px;
  line-height: 21px;
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  font-family: Vodafone Rg;
  color: white;

  ${props => {
    let backgroundColor = "";
    const fontColor = props.theme.palette.white;
    let borderColor = "";
    switch (props.status) {
      case ReferralCampaignStatus.LIVE:
        backgroundColor = props.theme.palette.digitalGreen;
        borderColor = props.theme.palette.digitalGreen;
        break;
      case ReferralCampaignStatus.SCHEDULED:
        backgroundColor = props.theme.palette.turquoiseBlue;
        borderColor = props.theme.palette.turquoiseBlue;
        break;
      case ReferralCampaignStatus.DISABLED:
        backgroundColor = props.theme.palette.freshOrange;
        borderColor = props.theme.palette.freshOrange;
        break;
    }
    return `background-color: ${backgroundColor}; color: ${fontColor}; border: 1px solid ${borderColor}`;
  }}
`;
